import { parsePhoneNumber } from 'libphonenumber-js/max';

const emailRegex = new RegExp(/^(?=.{1,256}$)[^\s@]+@[^\s@]+\.[^\s@]+$/);

export const isValidEmail = (email: string): boolean => emailRegex.test(email);

export const isValidPhoneNumber = (number: string): boolean =>
  !/\D/.test(number);

export const isValidPhoneNumberForCountry = (
  number: string,
  countryCode: string | undefined,
  dialCode: string | undefined
): boolean => {
  const normalizedDialCode = dialCode?.replaceAll(' ', '');

  if (
    !number ||
    !countryCode ||
    !normalizedDialCode ||
    !/^\d+$/.test(number) ||
    !/^\d+$/.test(normalizedDialCode)
  ) {
    return false;
  }

  const serializedPhoneNumber = `+${normalizedDialCode}${number}`;

  try {
    const parsedPhoneNumber = parsePhoneNumber(serializedPhoneNumber);

    return (
      parsedPhoneNumber.isValid() &&
      parsedPhoneNumber.country === countryCode &&
      parsedPhoneNumber.number === serializedPhoneNumber
    );
  } catch {
    return false;
  }
};

export const isValidName = (value: string): boolean => value.trim().length >= 2;
